module.exports = __webpack_public_path__ + "static/img/unable.a493161b.png";